import * as React from 'react';

interface IProductCard {
  url: string;
  prodUrl: string;
  prodName: string;
  solutionName: string;
  description: string;
  tags: string[];
}

const ProductCard: React.FC<IProductCard> = ({
  url,
  prodName,
  solutionName,
  prodUrl,
  description,
  tags,
}) => {
  return (
    <a href={url} className="product-card">
      <div className="product-card__content">
      <div className='product-card__title'>
        <h3 className="product-card__solution">{solutionName}</h3>
        <h3 className="product-card__heading">{prodName}</h3>        
      </div>
        <div className="product-card__details">
          <div className="product-card__info-tags">             
          </div>
        </div>
        <p className="product-card__description">{description}</p>

        {tags.length > 0 && (
        <p className='product-card__tags-heading'>Features</p>
        )}
        {tags.length > 0 && (          
            <ul className="product-card__tags">
              {tags.map(tag => (
                <li key={tag} className="product-card__tag">
                  <a href={prodUrl}>{tag}</a>
                </li>
              ))}
            </ul>
        )}
      
      </div>
    </a>
  );
};

export default ProductCard;